import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { SemesterAttestationTypeResponse } from "../../models/dtos";

export const semesterAttestationTypesApi = createApi({
  reducerPath: 'semesterAttestationTypesApi',
  baseQuery: baseAuthQuery('SemesterAttestationTypes'),
  tagTypes: ['SemesterAttestationType'],
  endpoints: (builder) => ({
    getSemesterAttestationTypes: builder.query<ApiResponse<SemesterAttestationTypeResponse[]>, void>({
      query: () => "",
      providesTags: ['SemesterAttestationType'],
    }),
  }),
});
